require('./bootstrap');
// require('../../classic/_application/Scripts/PageY2Public.js')
require('./bouton-demarrer-chat')
require('./menu-principal')
// require('./chat')
require('./recherche')
require('./scroll-to-top-link')
require('./liens-externes')
require('./ping')
